import React from "react";

function Experience() {
  return (
    <section id="about" className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
            <div className="exp-num mb-100 wow zoomIn" data-wow-delay="0.3s">
              <h5 className="fsz-18 text-uppercase">
                years of <br /> experience
              </h5>
              <h2 className="num"> 9 </h2>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="img wow">
              <img
                src="/home1/assets/img/exp.webp"
                alt=""
                className="img-cover"
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30"> About </h3>
              <div className="text fsz-15 color-666">
                Tameer Builders & Developers is a distinguished name in the
                world of construction and design, recognized for redefining
                standards of quality, innovation, and cultural sensitivity in
                architecture. As creators and curators of sophisticated spaces,
                we’re dedicated to bringing visionary projects to life, from
                strikingly modern structures to timeless, classic designs that
                harmonize with their environment. Every project we undertake is
                a testament to our commitment to excellence, driven by a deep
                understanding of both the technical and artistic aspects of
                architecture and construction.
              </div>
              {/* <a
                href="#"
                className="butn rounded-pill mt-50 hover-bg-black bg-white"
              >
                <span>
                  Our Studio <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a> */}
            </div>
          </div>
          <div className="col-lg-2">
            <div className="rotate-txt justify-content-lg-end">
              <ul>
                <li>
                  <a href="mailto:info@tameer-egypt.com">
                    info@tameer-egypt.com
                  </a>{" "}
                </li>
                {/* <li>
                  <a href="tel:+20 11 1314 3450">+20 11 1314 3450</a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line.webp" alt="" className="c-line wow" />
    </section>
  );
}

export default Experience;
